import styled from 'styled-components';

export const SwitchWrapper = styled.span`
  display: block;
  margin: 0;
  text-align: center;
`;
